module.exports = __webpack_public_path__ + "static/media/back-arrow-icon.1304fdac.svg";